import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { Components } from 'safe'
import Form from '../../../components/Form'
import FormItem from '../../../components/Form/FormItem'
import Button from '../../../components/General/Button'
import CurrencyInput from '../../../components/Inputs/CurrencyInput'
import InputText from '../../../components/Inputs/InputText'
import SelectOfCategories from '../../../components/Inputs/SelectOfCategories'
import { RootState } from '../../../redux/store'
import { formatPipe } from '../../../utils/utils'
import { IGlobalRate } from '../../../views/Sells/Sells'

interface options {
  value: string
  text: string
}

interface ITransferPaymentForm {
  onSubmitProp: Function
  options: options[]
  onCancel: Function
  debt: string
  rate: IGlobalRate[]
}

export const TransferPaymentForm: React.FC<ITransferPaymentForm> = ({
  options,
  onCancel,
  onSubmitProp,
  debt,
  rate,
}) => {
  const form = useForm()

  const [selectedAccounts, setSelectedAccounts] = useState<any>([])

  const [selectedCurrency, setSelectedCurrency] = useState<any | null>(null)

  const accounts = useSelector(
    (state: RootState) => state.acct.accounts
  ).filter((v) => v.accountVisible)

  const onSubmit = (values): void => {
    if (selectedAccounts.length === 0) {
      form?.setError('type', {
        type: 'manual',
        message: 'No hay opciones disponibles',
      })
      return
    }
    console.log('Values', values)
    onSubmitProp({ ...values, amount: formatPipe(values.amount, true) })
  }

  // const onGetAccountsPhoneFormatter = (): options[] => {
  //   return accounts.reduce((a, b) => {
  //     if (b.mobilePaymentPhone) {
  //       return [...a, { text: b.description, value: b.id } as options]
  //     }
  //     return a as options[]
  //   }, [] as options[])
  // }

  const onGetAccountsFormatter = (): options[] => {
    return accounts.reduce((a, b) => {
      return [...a, { text: b.description, value: b.id } as options]
      return a as options[]
    }, [] as options[])
  }

  useEffect(() => {
    setSelectedAccounts(onGetAccountsFormatter())
    // form.setValue('amount', debt)
  }, [])

  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  return (
    <>
      <Form
        form={form}
        classes={`gap-x-6 gap-y-2`}
        // id={id}
        onSubmit={(values) => onSubmit(values)}
      >
        <div className="col-span-12" style={{ fontWeight: 500 }}>
          Transferencias
        </div>
        {/* <div className="col-span-12">DEUDA: BS {formatPipe(debt)}</div>
    <div className="col-span-12">DEUDA EN USD (REF.): { formatPipe((+debt / +(rate.find(r => r.id === "1")?.rate || 1)).toFixed(2)) }</div> */}

        {/* <div className="col-span-3">TIPO</div> */}

        {/* <FormItem name="type" classes="col-span-9" defaultValue={options[0]}>
      <Select
        options={options}
        setSelectedHelper={(v) => onUpdateAccounts(v)}
        label=""
      />
    </FormItem> */}

        {/* <div className={`col-span-3 ${windowSize.innerWidth < 1200 && 'truncate'}`}>CUENTA RECEPTORA</div> */}
        <FormItem
          name="type"
          classes="col-span-12"
          defaultValue={selectedAccounts[0]}
        >
          <SelectOfCategories
            onChange={(value: Components.SelectOption) => {
              let accountCurrency = accounts.find(
                (v) => v.id === value?.value
              )?.idCurrency
              let rateCurrency =
                rate.find((r) => r.id === accountCurrency)?.rate || 1
              setSelectedCurrency(accountCurrency)
              if (accountCurrency === '1') {
                form.setValue(
                  'amount',
                  `$ ${formatPipe(
                    (+debt / +rateCurrency).toFixed(2).replace('.', ',')
                  )}`
                )
              }
              if (accountCurrency === '2') {
                form.setValue(
                  'amount',
                  `Bs. ${formatPipe(
                    (+debt / +rateCurrency).toFixed(2).replace('.', ',')
                  )}`
                )
              }
            }}
            options={selectedAccounts}
            label="Cuenta"
            emptyText="No tienes cuentas agregadas. Agrega una cuenta en el modulo de Bancos"
          />
        </FormItem>

        {/* <div className="col-span-3">MONTO</div> */}
        <FormItem
          name="amount"
          classes="col-span-12"
          defaultValue={''}
          rules={{
            required: 'Es necesario el monto',
            // pattern: { value: /^\d+(\.\d{2})?$/, message: 'Monto inválido' },
          }}
        >
          {/* <InputText small maxLength={80} /> */}
          {/* <InputNumber addDecimals={true} label='Monto' /> */}
          <CurrencyInput
            addDecimals={true}
            label="Monto"
            mask={selectedCurrency === '1' ? '$ num' : 'Bs. num'}
          />
        </FormItem>

        {/* <div className="col-span-3">REF</div> */}
        <FormItem name="reference" classes="col-span-12" defaultValue={''}>
          <InputText small maxLength={80} label="Referencia" />
        </FormItem>

        <div className="col-span-12 h-full flex flex-row">
          <div className="w-1/2 mr-5 pl-1">
            <Button type="outline" classes="w-full" onClick={() => onCancel()}>
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button type="primary" classes="w-full" htmlType="submit">
              Continuar
            </Button>
          </div>
        </div>
      </Form>
    </>
  )
}
